/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-04-24 17:09:42
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2020-07-20 15:37:31
 * @Description: 电影模块
 * @FilePath: /src/api/modules/movie.js
 */ 
/**
 * 获取正在热映电影列表
 */
export const GET_HOST_MOVIE_LIST = '/api/v2/films/listByCityId';
/**
 * 获取 即将上映 电影列表
 */
export const GET_MOVIE_LIST = '/api/v2/films/pagedQuery';
/**
 * 获取电影详情
 */
export const GET_MOVIE_INFO = '/api/movie/details';
/**
 * 获取电影最近几日信息
 */
export const GET_MOVIE_INFO_DAY = '/api/movie/day';
/**
 * 获取电影所支持的影院
 */
export const GET_MOVIE_FOR_CINEMA_LIST = '/api/movie/cinemaList';
/**
 * 获取场次座位图信息
 */
export const GET_MOVIE_SCENE_INFO = '/api/v2/shows/getRealTimeSeatByShowId';
/**
 * 创建电影订单
 */
export const CREATE_MOVIE_ORDER = '/api/order/movie/createOrder';
/**
 * 查看趣满满价格
 */
export const GET_QMM_PRICE = '/api/supplier/getQmmPrice';